import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Typography, message, Divider, Space } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import { authAPI } from '../services/api';

const { Title } = Typography;

const AccountSettings: React.FC = () => {
  const { user, refreshUser } = useAuth();
  const { currentTenant } = useTenant();
  const [profileForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [changingPwd, setChangingPwd] = useState(false);

  useEffect(() => {
    if (user) {
      profileForm.setFieldsValue({
        real_name: user.real_name || '',
        username: user.username || '',
        email: user.email,
        phone: user.phone || '',
      });
    }
  }, [user, profileForm]);

  const handleProfileSave = async (values: any) => {
    setSaving(true);
    try {
      await authAPI.updateMe({
        real_name: values.real_name,
        username: values.username,
        phone: values.phone,
      });
      await refreshUser();
      message.success('个人信息已更新');
    } catch (err: any) {
      message.error(err?.response?.data?.detail || '更新失败');
    } finally {
      setSaving(false);
    }
  };

  const handlePasswordChange = async (values: any) => {
    setChangingPwd(true);
    try {
      await authAPI.changePassword({
        current_password: values.current_password,
        new_password: values.new_password,
      });
      message.success('密码已修改');
      passwordForm.resetFields();
    } catch (err: any) {
      message.error(err?.response?.data?.detail || '修改密码失败');
    } finally {
      setChangingPwd(false);
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 640 }}>
      <Title level={4}>账户设置</Title>

      <Card title="个人信息" style={{ marginBottom: 16 }}>
        <Form form={profileForm} layout="vertical" onFinish={handleProfileSave}>
          <Form.Item label="真实姓名" name="real_name" rules={[{ required: true, message: '请输入真实姓名' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="用户名" name="username">
            <Input placeholder="用于显示的昵称" />
          </Form.Item>
          <Form.Item label="邮箱" name="email">
            <Input disabled />
          </Form.Item>
          <Form.Item label="手机号" name="phone">
            <Input />
          </Form.Item>
          <Form.Item label="所属机构">
            <Input value={currentTenant?.name || '-'} disabled />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>保存</Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="修改密码">
        <Form form={passwordForm} layout="vertical" onFinish={handlePasswordChange}>
          <Form.Item label="当前密码" name="current_password" rules={[{ required: true, message: '请输入当前密码' }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item label="新密码" name="new_password" rules={[
            { required: true, message: '请输入新密码' },
            { min: 6, message: '密码至少6位' },
          ]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="确认新密码"
            name="confirm_password"
            dependencies={['new_password']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) return Promise.resolve();
                  return Promise.reject(new Error('两次密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={changingPwd}>修改密码</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AccountSettings;
